module.exports = __webpack_public_path__ + "static/media/MonumentExtended-Ultrabold.3b240783.otf";